export { default } from './AlarmsTab'
